import React from 'react';
import { Link } from 'react-router-dom';
import logo from '../assets/ibs-logo.jpg';

const Logo = ({ height = '40px', width = 'auto' }) => {
  return (
    <Link to="/">
      <img className=" h-auto w-auto inline  ml-8" src={logo} alt="Logo" style={{ height, width }} />
    </Link>
  );
};

export default Logo;
